import React, {useEffect, useState} from 'react';
import Box from "@mui/material/Box";
import { JsonApiClient, createCache } from "@drupal-api-client/json-api-client";
import { Jsona } from "jsona";
import {ICart, ICartProps, IOrderItem} from "./Cart";
import TextField from "@mui/material/TextField";
import {
  Button, Dialog, DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import axios, {AxiosPromise} from "axios";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Config from "../../utils/Config";


export interface ICheckoutProps {

}

const client = new JsonApiClient(Config.getDrupalVar('path.baseRoot') + Config.getDrupalVar('path.baseUrl'), {

  serializer: new Jsona()
});




const Checkout = (props: ICheckoutProps) => {


  const [cart, setCart] = useState<ICart[]>([]);
  const [submitting, setSubmitting] = useState<boolean>(true);
  const [open, setOpen] = React.useState(false);

  // The two-letter country code.
  const [countryCode, setCountryCode] = React.useState('');
  //The locality (i.e. city).
  const [locality, setLocality] = React.useState('');

  //The postal code.
  const [postalCode, setPostalCode] = React.useState('');
  // The first line of the address block.
  const [addressLine1, setAddressLine1] = React.useState('');
  // The second line of the address block.
  const [addressLine2, setAddressLine2] = React.useState('');
  // The organization
  const [organization, setOrganization] = React.useState('');
  // The given name.
  const [givenName, setGivenName] = React.useState('');
  // The family name.
  const [familyName, setFamilyName] = React.useState('');


  const getCart = async () => {
    const carts = await client.getCollection("carts") as any;
    console.log('Carts:', carts);
    setCart(carts);
    setSubmitting(false);
  };

  useEffect(() => {
    getCart();
  }, []);


  const prepareOrder = (cartToken: string) : AxiosPromise => {
    return axios({
      url: Config.getDrupalVar('path.baseRoot') + Config.getDrupalVar('path.baseUrl') + 'jsonapi/checkout/' + cart[0].id ,
      params: {
        cartToken: cartToken
      },
      data:
        {
          data: [{
            // "type": cart[0]?.default_variation.type,
            // "id": cart[0]?.default_variation.id,
          }],
        },
      method: 'GET',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
      },
    });
  }

  const setPayment = (cartToken: string) : AxiosPromise => {
    return axios({
      url: Config.getDrupalVar('path.baseRoot') + Config.getDrupalVar('path.baseUrl') + 'jsonapi/checkout/' + cart[0].id ,
      params: {
        cartToken: cartToken
      },
      data: {
        data: {
          id: cart[0].id,
          type: cart[0].type,
          attributes: {
            "payment_instrument": {
              "payment_gateway_id": "pay_on_account",
              "payment_details": {
              },
            },
            billing_information: {
              address: {

                country_code: "DE",
                administrative_area: null,
                dependent_locality: null,
                sorting_code: null,
                additional_name: null,

                given_name: givenName,
                family_name: familyName,
                organization: organization,
                address_line1: addressLine1,
                address_line2: addressLine2,
                postal_code: postalCode,
                locality: locality
              }
            }
          }
        },
      },
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
      },
    });
  }

  // const createProfile = (cartToken: string) : AxiosPromise => {
  //   return axios({
  //     url: Config.getDrupalVar('path.baseRoot') + Config.getDrupalVar('path.baseUrl') + 'jsonapi/profile/customer',
  //     params: {
  //       cartToken: cartToken
  //     },
  //     data: {
  //       data: {
  //         type: "profile--customer",
  //         attributes: {
  //           status: true,
  //           is_default: true,
  //           address: {
  //             country_code: "DE",
  //             administrative_area: null,
  //             dependent_locality: null,
  //             sorting_code: null,
  //             additional_name: null,
  //
  //             given_name: givenName,
  //             family_name: familyName,
  //             organization: organization,
  //             address_line1: addressLine1,
  //             address_line2: addressLine2,
  //             postal_code: postalCode,
  //             locality: locality
  //           }
  //         },
  //       },
  //     },
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/vnd.api+json',
  //       'Accept': 'application/vnd.api+json',
  //     },
  //   });
  // }

  const placeOrder = (cartToken: string) : AxiosPromise => {
    return axios({
      url: Config.getDrupalVar('path.baseRoot') + Config.getDrupalVar('path.baseUrl') + 'jsonapi/checkout/' + cart[0].id + '/payment',
      params: {
        cartToken: cartToken
      },
      data: {
        data: {
          type: 'payment--payment-manual',
          attributes: {
            capture: true,
          }
        },
      },
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
      },
    });
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitting(true)

    const cartToken = localStorage.getItem('cartToken') || Math.random().toString(36).substr(2);
    localStorage.setItem('cartToken', cartToken);

    prepareOrder(cartToken).then(function(result) {
      return setPayment(cartToken);
    }).then(function(result) {
      return setPayment(cartToken);
    }).then(function(result) {
      return placeOrder(cartToken);
    }).then(function(result) {
      setOpen(true);
      setSubmitting(false);
    }).catch(error => {
      setSubmitting(false);
      // console.log('Error on adding to cart', error);
      // return Promise.reject(new Error(`Error on adding to cart: ${error.response.data.message}`));
    });



  };

  return (
    <div className="font-[sans-serif] bg-white p-4">
      <Dialog
        open={open}
        keepMounted
        onClose={() => {}}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{""}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Die Bestellung war erfolgreich. Wir melden uns bei Ihnen.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => window.location.href = '/'} variant="contained" >Ok</Button>
        </DialogActions>
      </Dialog>
      {cart[0] && <>
        <div className="md:max-w-5xl max-w-xl mx-auto">
          <h2 className="text-3xl font-extrabold text-gray-800">Zahlung</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2 max-md:order-1">

              {/*<p className="text-gray-800 text-sm mt-4">Complete your transaction*/}
              {/*  swiftly and securely with our easy-to-use payment process.</p>*/}

              {/*<form className="mt-8 max-w-lg">*/}
              {/*  <div className="grid gap-4">*/}
              {/*    <div>*/}
              {/*      <input type="text" placeholder="Cardholder's Name"*/}
              {/*             className="px-4 py-3.5 bg-gray-100 text-gray-800 w-full text-sm border rounded-md focus:border-purple-500 focus:bg-transparent outline-none"/>*/}
              {/*    </div>*/}

              {/*    <div*/}
              {/*      className="flex bg-gray-100 border rounded-md focus-within:border-purple-500 focus-within:bg-transparent overflow-hidden">*/}
              {/*      <svg xmlns="http://www.w3.org/2000/svg" className="w-6 ml-3"*/}
              {/*           viewBox="0 0 32 20">*/}
              {/*        <circle cx="10" cy="10" r="10" fill="#f93232"*/}
              {/*                data-original="#f93232"/>*/}
              {/*        <path fill="#fed049"*/}
              {/*              d="M22 0c-2.246 0-4.312.75-5.98 2H16v.014c-.396.298-.76.634-1.107.986h2.214c.308.313.592.648.855 1H14.03a9.932 9.932 0 0 0-.667 1h5.264c.188.324.365.654.518 1h-6.291a9.833 9.833 0 0 0-.377 1h7.044c.104.326.186.661.258 1h-7.563c-.067.328-.123.66-.157 1h7.881c.039.328.06.661.06 1h-8c0 .339.027.67.06 1h7.882c-.038.339-.093.672-.162 1h-7.563c.069.341.158.673.261 1h7.044a9.833 9.833 0 0 1-.377 1h-6.291c.151.344.321.678.509 1h5.264a9.783 9.783 0 0 1-.669 1H14.03c.266.352.553.687.862 1h2.215a10.05 10.05 0 0 1-1.107.986A9.937 9.937 0 0 0 22 20c5.523 0 10-4.478 10-10S27.523 0 22 0z"*/}
              {/*              className="hovered-path" data-original="#fed049"/>*/}
              {/*      </svg>*/}
              {/*      <input type="number" placeholder="Card Number"*/}
              {/*             className="px-4 py-3.5 text-gray-800 w-full text-sm outline-none bg-transparent"/>*/}
              {/*    </div>*/}

              {/*    <div className="grid grid-cols-2 gap-4">*/}
              {/*      <div>*/}
              {/*        <input type="number" placeholder="EXP."*/}
              {/*               className="px-4 py-3.5 bg-gray-100 text-gray-800 w-full text-sm border rounded-md focus:border-purple-500 focus:bg-transparent outline-none"/>*/}
              {/*      </div>*/}
              {/*      <div>*/}
              {/*        <input type="number" placeholder="CVV"*/}
              {/*               className="px-4 py-3.5 bg-gray-100 text-gray-800 w-full text-sm border rounded-md focus:border-purple-500 focus:bg-transparent outline-none"/>*/}
              {/*      </div>*/}
              {/*    </div>*/}
              {/*  </div>*/}

              {/*  <button type="button"*/}
              {/*          className="mt-8 w-40 py-3.5 text-sm bg-purple-500 text-white rounded-md hover:bg-purple-600 tracking-wide">Pay*/}
              {/*  </button>*/}
              {/*</form>*/}
              <Box component="form" onSubmit={handleSubmit}
                   sx={{mt: 1}}>
                <div className="grid gap-2 grid-cols-2">
                  <TextField
                    required
                    label="Vorname"
                    fullWidth
                    sx={{mb: 2}}
                    value={givenName}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setGivenName(event.target.value);
                    }}
                  />
                  <TextField
                    required
                    label="Nachname"
                    fullWidth
                    sx={{mb: 2}}
                    value={familyName}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setFamilyName(event.target.value);
                    }}
                  />
                </div>
                <TextField
                  label="Firma"
                  fullWidth
                  sx={{mb: 2}}
                  value={organization}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setOrganization(event.target.value);
                  }}
                />
                <TextField
                  required
                  label="Straße und Hausnummer"
                  fullWidth
                  sx={{mb: 2}}
                  value={addressLine1}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setAddressLine1(event.target.value);
                  }}
                />
                {/*<TextField*/}
                {/*  label="Adresszusatz"*/}
                {/*  fullWidth*/}
                {/*  sx={{mb: 2}}*/}
                {/*  value={addressLine2}*/}
                {/*  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {*/}
                {/*    setAddressLine2(event.target.value);*/}
                {/*  }}*/}
                {/*/>*/}
                <div className="grid grid-cols-3 gap-2">
                  <TextField
                    required
                    label="Postleitzahl"
                    fullWidth
                    sx={{mb: 2}}
                    value={postalCode}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setPostalCode(event.target.value);
                    }}
                  />
                  <div className="col-span-2">
                    <TextField
                      required
                      label="Ort"
                      fullWidth
                      sx={{mb: 2}}
                      value={locality}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setLocality(event.target.value);
                      }}
                    />
                  </div>
                </div>

                <FormControlLabel required control={<Checkbox/>}
                                  label="Ich stimme den AGBs zu."/>
                <Button type="submit" variant="contained" disabled={submitting}
                        fullWidth sx={{marginTop: 4}}>
                  Jetzt kostenpflichtig bestellen
                </Button>
              </Box>
            </div>

            <div className="bg-gray-100 p-6 rounded-md">
              <h2 className="text-3xl font-extrabold text-gray-800">{cart[0]?.total_price?.formatted}</h2>

              <ul className="text-gray-800 mt-8 space-y-4">
                {cart[0]?.order_items?.map((item, i) =>
                  <li className="flex flex-wrap gap-4 text-sm">{ item.title } <span
                    className="ml-auto font-bold">{ item.total_price.formatted }</span></li>

                )}


                {/*<li className="flex flex-wrap gap-4 text-sm">Tax <span*/}
                {/*  className="ml-auto font-bold">$10.00</span></li>*/}
                <li
                  className="flex flex-wrap gap-4 text-sm font-bold border-t-2 pt-4">Gesamt <span
                  className="ml-auto">{cart[0]?.total_price?.formatted}</span></li>
              </ul>
            </div>
          </div>
        </div>
      </>}
    </div>

  );
};

export default Checkout;
